import styled from 'styled-components'
import { TRANSITIONS, TYPOGRAPHY, FONT_WEIGHT } from '../../../../../styles/theme'
import { getContrastingTextColor } from '../../../../../utils/colorUtils'

// Remove button for label chips - shows on hover
export const RemoveLabelButton = styled.button<{ $bgColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.$bgColor && getContrastingTextColor(props.$bgColor) === 'white'
      ? 'rgba(0, 0, 0, 0.2)'
      : 'rgba(255, 255, 255, 0.3)'};
  border: none;
  border-radius: 4px;
  width: 14px;
  height: 14px;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  transition: all ${TRANSITIONS.fast};
  flex-shrink: 0;
  color: ${(props) => (props.$bgColor ? getContrastingTextColor(props.$bgColor) : 'white')};

  &:hover {
    background: ${(props) =>
      props.$bgColor && getContrastingTextColor(props.$bgColor) === 'white'
        ? 'rgba(0, 0, 0, 0.4)'
        : 'rgba(255, 255, 255, 0.5)'};
    opacity: 1 !important;
  }

  &:active {
    transform: scale(0.9);
  }
`

export const LabelChip = styled.div<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: ${(props) => props.$color};
  color: ${(props) => getContrastingTextColor(props.$color)};
  padding: 4px 10px;
  border-radius: 4px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.bold};
  max-width: 150px;
  transition: all ${TRANSITIONS.fast};
  cursor: default;

  &:hover {
    ${RemoveLabelButton} {
      opacity: 1;
    }
  }
`

export const LabelChipText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
